import { render } from "./BurgerForm.vue?vue&type=template&id=41871f3a&scoped=true"
import script from "./BurgerForm.vue?vue&type=script&lang=js"
export * from "./BurgerForm.vue?vue&type=script&lang=js"

import "./BurgerForm.vue?vue&type=style&index=0&id=41871f3a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41871f3a"]])

export default __exports__